module.exports = __webpack_public_path__ + "img/fellowship-blue.28648c0d.svg";